<app-datatable
  [dataSource]="workerSource"
  [columns]="columns"
  [identifier]="'worker'"
  [actionNew]="canWriteWorkers"
  [customActions]="customActions"
  (newEvent)="new()"
  (showEvent)="canWriteWorkers && edit($event.valueOf())"
>
  <app-empty-table
    [icon]="'engineering'"
    [emptyText]="'worker.empty_text' | translate"
    [buttonText]="canWriteWorkers ? ('worker.new' | translate) : undefined"
    (btnClick)="new()"
  >
  </app-empty-table>
</app-datatable>

@if (canWriteWorkers) {
  <app-model-modal #EditWorkerModal (saveEvent)="onSave()">
    <app-worker-form #form (closeEvent)="onModalClose()"></app-worker-form>
  </app-model-modal>
}

<ng-template #unpairActiveWorkerQuestionModal>
  <div class="modal-header">
    <h4 class="modal-title">
      {{ 'worker.unpair-active-question-title' | translate }}
    </h4>
    <button
      type="button"
      class="btn-close"
      (click)="modalRef?.close()"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body">
    <p>{{ 'worker.unpair-active-question' | translate }}</p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="modalRef?.close()"
    >
      {{ 'cancel' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-danger"
      (click)="modalRef?.close('unpair')"
    >
      {{ 'worker.unpair' | translate }}
    </button>
  </div>
</ng-template>
